import React, { useContext } from 'react';
import { ThemeContext } from '../../context/ThemeProvider';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Screenshots from './components/Screenshots';
import Pricing from './components/Pricing';
import Footer from './components/Footer';
import KeyStats from './components/KeyStats';
import StudyAnywhere from './components/StudyAnywhere';
import { landingPageConfig } from '../../../app_constant/landingPageConfig';
import  SuccessGuaranteeBadge  from './components/SuccessGuaranteeBadge';

const LandingPageScreen = () => {
  const { theme, currentTheme, setCurrentTheme } = useContext(ThemeContext);

  const sectionStyle = {
    background: `linear-gradient(to bottom, ${theme?.neutral?.white} 0%, ${theme?.neutral?.white} 70%, ${theme?.neutral?.gray?.[50]} 85%, ${theme?.neutral?.gray?.[50]} 95%, ${theme?.neutral?.gray?.[50]} 100%)`,
    marginTop: 'clamp(1.5rem, 4vw, 2.5rem)',
    paddingBottom: 'clamp(1rem, 3vw, 1.5rem)',
    paddingLeft: '1rem',
    paddingRight: '1rem',
  };

  const {
    appConfig,
    keyStats,
    platforms,
    faqData,
    certificationData,
    featuresData,
    screenshotsData,
    contactData,
    footerData
  } = landingPageConfig;
  const phoneImage = "/assets/images/hero-images/phone.png";
  const tabletImage = "/assets/images/hero-images/tablet.png";
  const webImage = "/assets/images/hero-images/web.png";

  const onToggleTheme = () => {
    const body = document.body;
    const newTheme = currentTheme === "light" ? "dark" : "light";
    localStorage.setItem("Theme", newTheme);
    setCurrentTheme(newTheme);
    body.classList.toggle("dark", newTheme === "dark");
  };

  return (
    <div className="min-h-screen" style={{ background: theme?.neutral?.white }}>
      <Header
        logo={appConfig.logo}
        navItems={appConfig.navItems}
        onThemeChange={onToggleTheme}
        currentTheme={currentTheme}
        theme={theme}
      />
      <div style={sectionStyle}>
      <Hero
        title={appConfig.hero.title}
        subtitle1={appConfig.hero.subtitle1}
        subtitle2={appConfig.hero.subtitle2}
        stats={keyStats}
        appIcon={appConfig.hero.appIcon}
        heroImage={appConfig.hero.heroImage}
        phoneImage={phoneImage}
        tabletImage={tabletImage}
        webImage={webImage}
        heroImageDark={appConfig.hero.heroImageDark}
        downloadLinks={appConfig.hero.downloadLinks}
        theme={theme}
        currentTheme={currentTheme}
      />
      
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', paddingBottom: '10px', paddingTop: '10px'}}>
        <SuccessGuaranteeBadge theme={theme} />
      </div>
      </div>
      <div style={sectionStyle}>
      <StudyAnywhere
        studyAnywhere={appConfig.studyAnywhere}
        downloadLinks={appConfig.downloadLinks}
        theme={theme}
      />
      </div>
      <div style={sectionStyle}>
      <KeyStats 
        stats={keyStats}
        theme={theme}
      />
      </div>
      <div style={sectionStyle}>
      <Features
        title={featuresData.title}
        subtitle={featuresData.subtitle}
        features={featuresData.items}
        theme={theme}
      />
      </div>
      
      <div style={sectionStyle}>
      <Screenshots
        screenshotsData={screenshotsData}
        theme={theme}
      />
      </div>

     
<div style={sectionStyle}>
      <Pricing theme={theme} />
      </div>
      

      <Footer
        footerData={footerData}
        theme={theme}
      />
    </div>
  );
};

export default LandingPageScreen; 